import type { AppProps } from 'next/app'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { appWithTranslation } from 'next-i18next'
import Router from 'next/router'
import { useEffect } from 'react'
import * as ga from '../utils/libs/ga4'
import '../styles/globals.css'
import '../styles/modal.css'
import '../build/css/_variables.css'
import Head from 'next/head'
import { hotjarInit } from '../utils/libs/hotjar'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  },
})

const MyApp = ({ Component, pageProps }: AppProps) => {
  useEffect(() => {
    const handleRouteChange = (url: string) => {
      ga.pageview(url)
    }
    hotjarInit(process.env.HOTJAR_ID, process.env.HOTJAR_SV)
    Router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentUrl = window.location.href;
      if (currentUrl.includes('www.')) {
        const newUrl = currentUrl.replace('www.', '');
        window.location.href = newUrl;
      }
    }
  }, []);

  return (
    <>
      <Head>
        <link rel='icon' href='/favicon.ico' />
      </Head>
      <QueryClientProvider client={queryClient}>
        <Component {...pageProps} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  )
}

export default appWithTranslation(MyApp)
